import ExternalLink from 'client/js/util/external_link';
import {Redirect} from 'react-router-dom';
import {GenericReactForm, StringInput, SubmitButton, FormActions, RadioCollectionInput, BooleanInput} from 'client/js/util/form_utils';
import {PageHeader} from 'client/js/util/layout_utils';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useResource } from 'client/js/util/rest_utils';

const ShowOnSslError = ({children}, {formData, serverErrors}) => {
  if((!formData || !formData.ssl_ignore_errors) && (!serverErrors || !serverErrors.hostname || !serverErrors.hostname.length))
    return null;

  return children;
}

ShowOnSslError.contextTypes = {
  formData: PropTypes.object,
  serverErrors: PropTypes.object
};

const Form = ({ match }) => {
  const mailbox_id = match.params.mailbox_id;
  const [import_id, setImportId] = useState(null);
  const { data, component } = useResource(['mailbox', match.params.mailbox_id], `/usercp/mailboxes/${match.params.mailbox_id}.json`);

  const dispatch = (action, original_event, data) => {
    if (action === 'form:success') {
      setImportId(data.object.id);
    }
  };

  if (import_id) {
    return <Redirect to={`/mailboxes/${mailbox_id}/imports/${import_id}`} />;
  }

  if (component) return component;

  return (
    <>
      <PageHeader text="E-Mail importieren" back_url={`/mailboxes/${mailbox_id}`} />

      <p>Mit diesem Werkzeug kannst Du die E-Mails und E-Mail-Ordner von einem fremden Server in das Postfach importieren. Es werden dazu alle E-Mails von dem unten angegebenen Server heruntergeladen und in das Postfach übertragen. Es werden keine Nachrichten gelöscht, weder auf dem Quell-, noch auf dem Ziel-Postfach. Obwohl wir das Passwort für das Quell-Postfach nach dem Import löschen empfehlen wir, ein neues Passwort für den Import anzulegen. <ExternalLink href="/hilfe/email-import-hinweise">Tipps zum E-Mail-Import</ExternalLink></p>

      <p><strong>Bitte beachte dass Zugriff auf das Postfach auf unserem Server während des laufenden E-Mail-Imports nicht möglich ist! Clients (Webmail, iPhone, Outlook etc.) werden während des laufenden Imports fehlerhafte Zugangsdaten melden.</strong></p>

      <GenericReactForm namespace="import" defaults={{port: 993, encryption: 'ssl'}} url={`/usercp/mailboxes/${mailbox_id}/imports`} dispatch={dispatch}>
        <div className="row form-group">
          <div className="col-form-label col-md-3">Ziel-Postfach</div>
          <div className="col-md-9 col-form-label">
            <span className="form-control-static text-muted">{data.mailbox.email}</span>
          </div>
        </div>
        <StringInput name="hostname" label="Server-Name" required />
        <RadioCollectionInput required name="encryption" label="Verschlüsselung" options={{ "tls": "TLS/STARTTLS", "ssl": "SSL" }} />
        <ShowOnSslError>
          <BooleanInput name="ssl_ignore_errors" label="Ungültiges SSL-Zertifikat akzeptieren" hint="Wenn der Server im SSL-Zertifikat einem anderen Namen ausweist, ein selbstsigniertes Zertifikat verwendet wird oder das Zertifikat abgelaufen ist, kannst Du diese Option aktivieren." />
        </ShowOnSslError>
        <StringInput name="port" type="number" label="Port" required hint="Für TLS/STARTTLS typischerweise 143, für SSL 993" />
        <StringInput name="username" label="Benutzername" required />
        <StringInput name="password" type="password" label="Passwort" required />

        <FormActions>
          <SubmitButton icon="plus" text="E-Mail importieren" />
        </FormActions>
      </GenericReactForm>
    </>
  );
};

Form.propTypes = {
  match: PropTypes.object.isRequired,
};

export default Form;
